export default __webpack_public_path__ + "static/media/Verified_icon.30e3e8a1.svg";